(function ($) {
    var mSearchObjectCounter = 0;

    $.widget("ui.Search",
        {
            options:
            {
                PageContentId: null,
                NavigationUrl: "/Core/Search/Search/",
                InitialPagerData: null,
                LoadingHTML: '<div>'
                    + '<img src="/img/spacer.gif" alt="Loading Search..." title="Loading Search..."/>'
                    + '<div>Loading...</div>'
                    + '</div>',
                ErrorHTML: '<div>'
                    + '<img src="/img/spacer.gif" alt="Error Loading Search." title="Error Loading Search."/>'
                    + '<div>Error Loading Search.</div>'
                    + '</div>',
                NotFoundHTML: '<div class="notfound">No items were found matching your search.  Please change your search and try again.</div>',
                ResultListSelector: '.pager_content'
            },

            _destroy: function () {
            },

            _init: function () {
                FBCommon_1_2.initTabs();
            },

            _MyObjectNumber: null,
            _MySubObjectNumber: null,

            _create: function () {
                var self = this;
                var jElement = $(self.element);

                if (self.options.PageContentId === null) {
                    return;
                }

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.ResultListSelector)) {
                    FBUtilities.LogMessage('Search - required settings null or empty.');
                    return;
                }

                mSearchObjectCounter = mSearchObjectCounter += 1;
                self._MyObjectNumber = self.options.PageContentId; //mSearchObjectCounter;
                self._MySubObjectNumber = 1;

                var lSearchResultId = 'SearchResult' + self._MyObjectNumber;

                var lResultsContainer = jElement.find(self.options.ResultListSelector);
                lResultsContainer.attr('role', 'region');
                lResultsContainer.attr('aria-live', 'polite');

                self.SetupPagination();

                var lSearchButton = jElement.find('.search_button');
                lSearchButton.click(function (aEvent) {
                    aEvent.preventDefault();
                    self.Search();
                    return false;
                });
                lSearchButton.attr('aria-controls', lSearchResultId);

                var lFilterSearchText = jElement.find("#search_string");
                lFilterSearchText.attr('aria-controls', lSearchResultId);
                lFilterSearchText.on(
                    'keypress',
                    function (aEvent) {
                        if (aEvent.key === "Enter") {
                            aEvent.preventDefault();
                            self.Search();
                            return false;
                        }
                        // nevermind, carry on...
                        return true;
                    }
                );

				jElement.on(
                    'click',
					'.link_button',
                    function (aEvent) {
						var lButton = $(aEvent.target).closest('.link_button');
						if (lButton.length !== 1) {
							return false;
						}
						if (FBUtilities.IsStringEmptyOrWhitespace(lButton.data('href')))
						{
							return;
						}
						if (lButton.hasClass('disabled'))
						{
							return false;
						}
						aEvent.preventDefault();
						document.location = lButton.data('href');
						return false;
                    }
                );

                //self.Reset();
            },

            Reset: function () {
                var self = this;
                var jElement = $(self.element);
                var jFormDiv = jElement.find('.fbcms_search_form');

                // reset all input fields.
                jFormDiv.find('#search_string').val('');
                jElement.StoryPagination('ChangePage', 1);
            },

            Search: function () {
                var self = this;
                var jElement = $(self.element);
                var lForm = jElement.find('.fbcms_search_form form');
                lForm.find('.IsFromSearchForm').val('true');
                lForm.submit();
            },

            SetupPagination: function () {
                var self = this;
                var jElement = $(self.element);

                $.each(
                    jElement.find('.fbcms_pager'),
                    function (aIndex, aValue)
                    {
                        var lResultsContainer = $(aValue).prev(self.options.ResultListSelector);
                        var lSearchResultId = 'SearchResult' + self._MyObjectNumber + '_' + self._MySubObjectNumber; 

                        var lSearchDataReferenceType = lResultsContainer.data('fbpager-datatype');

                        lResultsContainer.attr('id', lSearchResultId);

                        self._MySubObjectNumber += 1;

                        $(aValue).SearchPagination(
                            {
                                NavigationUrl: self.options.NavigationUrl + self.options.PageContentId + '/',
                                OnChange: function () {
                                    lResultsContainer.html(self.options.LoadingHTML);
                                },
                                OnSuccess: function (data, textStatus, jqXHR) {
                                    lResultsContainer.html(data);
                                },
                                OnError: function (jqXHR, textStatus, errorThrown) {
                                    lResultsContainer.html(self.options.ErrorHTML);
                                },
                                InitialPagerData: self.options.InitialPagerData,
                                LiveRegionId: lSearchResultId,
                                SearchDataReferenceType: lSearchDataReferenceType
                            });
                    }
                );
            }

        });

})(jQuery);
